// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"643":"aa9dbd6a","899":"be911637"}[chunkId] + ".chunk.js";
};